import React from "react";
import "./style.css";
import atmImage from "./assets/matm2.png";
import { FaRegLightbulb } from "react-icons/fa";

const MicroATMSection = () => {
  return (
    <>
      {/* ===== Banner Section ===== */}
      <section className="matm-banner">
        <div className="matm-overlay">
          <h2 className="matm-title">Micro ATM (mATM) Services</h2>
          <p className="matm-subtitle">
            Hassle-Free Cash Withdrawals & Banking Solutions
          </p>
        </div>
      </section>

      {/* ===== ATM Image Section ===== */}
      <section className="matm-image-section">
        <div className="matm-image-wrapper">
          <img src={atmImage} alt="Micro ATM" className="matm-img" />
        </div>
      </section>

      {/* ===== Description Section ===== */}
      <section className="matm-desc-section">
        <p>
          Micro ATM (mATM) services bring secure, seamless, and efficient
          financial transactions to regions where traditional banking access is
          limited. These compact devices act as portable mini bank terminals,
          allowing users to withdraw cash, check balances, and complete
          essential banking tasks using debit cards or Aadhaar-based
          authentication.
        </p>

        <p>
          As a trusted Micro ATM Service Provider, Omeswara delivers a robust
          and reliable infrastructure that enables uninterrupted banking
          services—ensuring financial accessibility for customers across rural
          and urban India Businesses seeking the best Micro ATM solutions can
          enhance customer engagement, generate new revenue streams, and support
          financial inclusion. Whether for small retailers, local shops, or
          remote communities, Omeswara’s mATM services help bridge the gap
          between customers and banking institutions through secure technology
          and modern payment systems.
        </p>
      </section>

      {/* ===== Why Choose Section ===== */}
      <section className="why-matm-section">
        <h2 className="why-title">Why Choose Our Omeswar mATM Services?</h2>

        <div className="why-grid">
          <div className="why-card">
            <div className="why-icon">
              <FaRegLightbulb />
            </div>
            <h3 className="why-card-title">Instant Cash Withdrawal</h3>
            <p className="why-card-text">
              Omeswara’s mATM device enables quick, secure cash withdrawals
              using debit cards or Aadhaar authentication, ensuring users can
              access funds whenever needed.
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaRegLightbulb />
            </div>
            <h3 className="why-card-title">Low-Cost Investment</h3>
            <p className="why-card-text">
              Start offering banking services with minimal setup costs. Omeswara
              provides affordable and scalable Micro ATM solutions ideal for
              retailers, agents, and small businesses.
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaRegLightbulb />
            </div>
            <h3 className="why-card-title">Multiple Bank Support</h3>
            <p className="why-card-text">
              Our mATM platform supports multiple banks, allowing customers to
              conveniently withdraw cash or check balances from their preferred
              accounts.
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaRegLightbulb />
            </div>
            <h3 className="why-card-title">Boost Your Business Earnings</h3>
            <p className="why-card-text">
              Increase your store footfall and earn attractive commissions by
              offering secure, Aadhaarenabled and card-based transactions
              through Omeswara’s Micro ATM network.
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaRegLightbulb />
            </div>
            <h3 className="why-card-title">Aadhaar-Enabled Banking</h3>
            <p className="why-card-text">
              As a leading Micro ATM Service Provider, Omeswara offers seamless
              AEPS-powered banking—including cash withdrawals, balance checks,
              and fund transfers—without needing a full ATM setup.
            </p>
          </div>
        </div>
      </section>

      {/* ===== Features Section ===== */}
      <section className="features-section">
        <h2 className="features-title">
          Features of Our Omeswar mATM Services
        </h2>

        <div className="features-grid">
          <div className="feature-card">
            <h3 className="feature-title">Seamless Cash Withdrawals</h3>
            <p className="feature-text">
              Customers can withdraw cash instantly using Aadhaar or debit
              cards. Omeswara ensures smooth, secure, and dependable mATM
              transactions.
            </p>
          </div>

          <div className="feature-card">
            <h3 className="feature-title">Instant Fund Settlement</h3>
            <p className="feature-text">
              Experience fast, real-time settlements that improve your cash flow
              and enhance customer satisfaction. Perfect for high-volume retail
              setups.
            </p>
          </div>

          <div className="feature-card">
            <h3 className="feature-title">Secure & Reliable Transactions</h3>
            <p className="feature-text">
              Omeswara’s mATM platform uses advanced encryption and security
              protocols, ensuring every transaction is fraud-free and fully
              protected.
            </p>
          </div>

          <div className="feature-card">
            <h3 className="feature-title">User-Friendly & Portable</h3>
            <p className="feature-text">
              Our compact, easy-to-use mATM devices make banking accessible
              everywhere—from retail counters to remote villages.
            </p>
          </div>

          <div className="feature-card">
            <h3 className="feature-title">24/7 Customer Support</h3>
            <p className="feature-text">
              Omeswara’s support team is available around the clock to assist
              merchants with device issues, settlements, or transaction queries.
            </p>
          </div>
        </div>
      </section>

      {/* ===== How Does mATM Work Section ===== */}
      <section className="how-section">
        <h2 className="how-title">How Does Our mATM Work?</h2>

        <div className="how-grid">
          <div className="how-card">
            <p className="how-text">
              Swipe or Insert Debit Card into the Micro ATM device
            </p>
          </div>

          <div className="how-card">
            <p className="how-text">Enter the Amount & PIN.</p>
          </div>

          <div className="how-card">
            <p className="how-text">
              Authenticate via Aadhaar (optional for AEPS transactions)
            </p>
          </div>

          <div className="how-card">
            <p className="how-text">
              Receive Instant Cash along with a secure digital or printed
              receipt.
            </p>
          </div>
        </div>
      </section>

      {/* ===== Benefits Section (NEW ADDED) ===== */}
      <section className="benefit-section">
        <h2 className="benefit-title">
          Benefits of Our Omeswar mATM for Businesses
        </h2>

        <div className="benefit-grid">
          <div className="how-card">
            <p className="how-text">
              Increase customer footfall at your retail shop.
            </p>
          </div>

          <div className="how-card">
            <p className="how-text">
              Offer banking services in cash-limited or rural locations
            </p>
          </div>

          <div className="how-card">
            <p className="how-text">Earn commissions on every transaction</p>
          </div>

          <div className="how-card">
            <p className="how-text">
              Support multi-bank networks and multiple card schemes
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default MicroATMSection;
